/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Publication product type enumeration.
 */
export type ProductKind = typeof ProductKind[keyof typeof ProductKind];


export const ProductKind = {
  ebook: 'ebook',
  audio: 'audio',
} as const;
